import React, { FC, useEffect, useState } from 'react';
import { Superbet, formatCountdown } from "./helper";
import { Link } from "react-router-dom";
import {Alert} from "react-bootstrap";

interface Props {
    data: Superbet[];
    atagParams: string | null,
    mode?: string | null
}
interface Countdown {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}
type CountdownOrExpired = Countdown | "Expired";
const toAbsoluteCDN = (pathname: string) => process.env.REACT_APP_CDN_URL + pathname;
const toAssetsUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
const SuperbetLobbyConponent: FC<Props> = ({data, atagParams, mode}) => {

    const [countdowns, setCountdowns] = useState<{ [key: string]: CountdownOrExpired }>({});
    useEffect(() => {
        const intervals: NodeJS.Timeout[] = [];
        const updatedCountdowns: { [key: string]: CountdownOrExpired } = {};
        data.forEach((item, index) => {
            const countdown = formatCountdown(item.operator_time_expires);
            updatedCountdowns[item.code] = countdown;
            if (typeof countdown !== "string") {
                const intervalId = setInterval(() => {
                    const updatedCountdowns = { ...countdowns };
                    updatedCountdowns[item.code] = formatCountdown(item.operator_time_expires);
                    setCountdowns(updatedCountdowns);
                }, 1000);
                intervals.push(intervalId);
            }
        });

        setCountdowns(updatedCountdowns);
        return () => {
            intervals.forEach((intervalId) => clearInterval(intervalId));
        };
    }, [data]);
    return (
        <div className="col-12">
            {
                data.length > 0 ?
                    <div className="card superbet-lobby-card mt-3">
                        {/*<div className="card-header text-white">*/}
                        <div className="card-header">
                            Superbet
                        </div>
                        <ul className="list-group list-group-flush">
                            {data.map((item, index) => {
                                const countdown = formatCountdown(item.operator_time_expires)
                                return (
                                    <li className={`list-group-item ${index % 2 === 1 ? 'list-item-bg-dark' : 'list-item-bg-light'}`}
                                        key={index}>
                                        <Link
                                            to={atagParams ? `superbet/${item.code}?atag=${atagParams}` : `superbet/${item.code}`}
                                            className='d-flex justify-content-between align-items-center text-decoration-none text-green'
                                            target={mode === 'iframe' ? '_blank' : undefined}
                                        >
                            <span>
                                 <b>
                                     <span className='team mb-2'>
                                         <img width='25'
                                              src={toAbsoluteCDN(`teams/${item.event.home_team.id}.png`)}
                                              onError={(e) => {
                                                  const randomIndex = Math.floor(Math.random() * 4) + 1;
                                                  e.currentTarget.src = toAssetsUrl(`/assets/img/tshirt/tshirt${randomIndex}.webp`);
                                              }}
                                              alt="logo"/>
                                         <span className="team-name">{item.event.home_team.name}</span>
                                     </span>
                                     <span className='team'>
                                         <img
                                             width='25'
                                             src={toAbsoluteCDN(`teams/${item.event.away_team.id}.png`)}
                                             onError={(e) => {
                                                 const randomIndex = Math.floor(Math.random() * 4) + 1;
                                                 e.currentTarget.src = toAssetsUrl(`/assets/img/tshirt/tshirt${randomIndex}.webp`);
                                             }}
                                             alt="logo"/>
                                         <span className="team-name">{item.event.away_team.name}</span>
                                     </span>
                                 </b>
                            </span>
                                            <span className='quicktip-title'>
                                {item.title}
                            </span>
                                            <span className='expires d-flex align-content-center'>
                                        <i className="far fa-clock m-2"/>
                                        <span className='d-flex flex-column align-content-center expires-time'>
                                            <div>
                                                    {
                                                        countdown !== 'Expired' ? (
                                                            <span>
                                                               {
                                                                   countdown.days > 0 ?
                                                                       countdown.days + ' Days'
                                                                       : 'Today in'
                                                               }
                                                            </span>
                                                        ) : null
                                                    }
                                                </div>
                                                <div>
                                                    {
                                                        countdown !== 'Expired' ? (
                                                            <span>
                                                               {
                                                                   `${countdown.hours}:${countdown.minutes}:${countdown.seconds}'`
                                                               }
                                                            </span>
                                                        ) : null
                                                    }
                                                </div>
                                        </span>
                                    </span>
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>

                    </div>
                    : <Alert>Loading...</Alert>
            }
        </div>
    );
}

export default SuperbetLobbyConponent;
